import * as z from "zod";

export const ThemeSchema = z.object({
  id: z.string(),
  name: z.string(),
  iconUrl: z.string(),
});
export type Theme = z.infer<typeof ThemeSchema>;

export module Theme {
  export function createDefault(): Theme {
    return {
      id: "Placeholder",
      name: "Placeholder",
      iconUrl: "Placeholder",
    };
  }
}
